import EmptyState from "../UI/EmptyState";
import TalentoRow from "./TalentsByPlantelRow";

const TalentsByPlantelTable = ({ talents }) => {
  //   console.log(talents);
  if (!talents || talents.length === 0) {
    return (
      <EmptyState
        icon="ph:warning-light"
        title="No hay talentos"
        description="No se han registrado talentos para este plantel."
      />
    );
  }

  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>Talento</th>
            <th>Nombre del plantel</th>
            <th>Estatus</th>
            <th>Acciones</th>
          </tr>
        </thead>

        <tbody>
          {talents.map((talento) => (
            <TalentoRow key={talento.id} talento={talento} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TalentsByPlantelTable;
